import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { details, FetchEarningDetails } from "./PaymentSlice";
import BackButton from "./../../component/BackButton";
import DatePicker from "react-multi-date-picker";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { areaCodeListingSelector, FetchAreaCodeList } from "../areacode/slice";
import { SchoolListReducer } from "../slice";
import { CSVLink, CSVDownload } from "react-csv";
import Loader from "./../../component/Loader";
function TeacherEarningDetails() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector((state) => state?.payment?.detail);
  console.log(data, "earning data");
  const [loading, setLoading] = useState(false);
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [page, setPage] = useState("1");
  const [show, setShow] = useState(false);
  const [schoolId, setSchoolId] = useState("");
  const [areacode, setAreacode] = useState("");
  const [search, setSearch] = useState("");
  const Schoollist = useSelector((state) => state.main.schools);
  const teacher = useSelector((state) => state?.payment?.teacher);
  const arealist = useSelector(areaCodeListingSelector);
  const [limit, setLimit] = useState(10);
  const [submitting, setSubmitting] = useState(false);
  const adminPercent = 10;
  const [earnings, setEarnings] = useState({
    grossEarning: 0,
    netEarning: 0,
    adminEarning: 0,
  });
  const [csvData, setCsvData] = useState("");
  useEffect(() => {
    dispatch(FetchAreaCodeList({ page: 1, limit: 100000000 }));
  }, [dispatch]);

  useEffect(() => {
    if (areacode) {
      dispatch(
        SchoolListReducer({
          page: 1,
          limit: 100000000,
          search: "",
          areacode,
        })
      );
    }
  }, [dispatch, areacode]);
  useEffect(() => {
    setLoading(true);
    dispatch(
      FetchEarningDetails({
        teacherId: id,
        page: page,
        limit,
        areacode,
        schoolId,
        search,
        ...(start_date && { start_date: moment(start_date).format("YYYY-MM-DD") }),
        ...(end_date && { end_date: moment(end_date).format("YYYY-MM-DD") })
      })
    )
      .then((res) => {
        if (res?.payload?.code === 1) {
          setLoading(false);

          let adminCut = res?.payload?.data?.admin_percentage;
          let arr = res?.payload?.data?.earning_details;
          let a = 0;
          let n = 0;
          let g = 0;
          arr?.forEach((item) => {
            let x =
              Number(item?.amount) -
              (Number(item?.amount) * Number(adminCut)) / 100;
            a += (Number(item?.amount) * Number(adminCut)) / 100;
            g += Number(item?.amount);

            n += x;
          });
          setEarnings({
            grossEarning: parseFloat(g).toFixed(2),
            netEarning: parseFloat(n).toFixed(2),
            adminEarning: parseFloat(a).toFixed(2),
          });
          let ob = {
            res: res,
            earning: {
              grossEarning: parseFloat(g).toFixed(2),
              netEarning: parseFloat(n).toFixed(2),
              adminEarning: parseFloat(a).toFixed(2),
            },
          };
          return ob;
        }
      })
      .then((ot) => {
        if (ot?.res?.payload?.code === 1) {
          console.log(ot, "Ot");
          let arr = ot?.res?.payload?.data?.earning_details;
          let adminPercent = ot?.res?.payload?.data?.admin_percentage;
          let datas = arr.map((st) => {
            let student = st?.student_details;
            return {
              "Booking Id": st?.bookingId,
              "Student Id": st?.studentId,
              Date: st?.date,
              "First Name": student?.first_name,
              "Last name": student?.last_name,
              "Medical note": student?.medical_note,
              Address: student?.address,
              Discipline: student?.discipline_details?.name,
              Image: student?.image,
              "Emergency contactNo": student?.emergency_contactNo,
              "Emergency countryCode": student?.emergency_countryCode,
              Dob: student?.dob
                ? moment(student?.dob).format("DD MMM YYYY")
                : "",
              "Student type": student?.student_type,
              "Areacode details": student?.areacode_details?.areacode,
              "School details": student?.school_details?.name,
              "Gross amount": st?.amount,
              "Admin earning": st?.amount * adminPercent,
              "Net amount":
                Number(st?.amount) - Number((st?.amount * adminPercent) / 100),
              "Payment date": st?.createdAt
                ? moment(st?.createdAt).format("DD MMM YYYY")
                : "",
            };
          });
          setCsvData(datas);
        }
      });
  }, [dispatch, id, areacode, schoolId, limit, page, search, start_date, end_date]);

  useEffect(() => {
    return () => {
      dispatch(details(null));
    };
  }, [dispatch]);

  const handleSubmit = () => {
    if (id) {
      setSubmitting(true);
      dispatch(
        FetchEarningDetails({
          page: 1,
          limit: 10000,
          teacherId: id,
          start_date: moment(start_date).format("YYYY-MM-DD"),
          end_date: moment(end_date).format("YYYY-MM-DD"),
        })
      ).then((res) => {
        setSubmitting(false);
        if (res?.payload?.code === 1) {
          setShow(!show);
          let adminCut = res?.payload?.data?.admin_percentage;
          let arr = res?.payload?.data?.earning_details;
          let a = 0;
          let n = 0;
          let g = 0;
          arr?.forEach((item) => {
            let x =
              Number(item?.amount) -
              (Number(item?.amount) * Number(adminCut)) / 100;
            a += (Number(item?.amount) * Number(adminCut)) / 100;
            g += Number(item?.amount);

            n += x;
          });
          setEarnings({
            grossEarning: parseFloat(g).toFixed(2),
            netEarning: parseFloat(n).toFixed(2),
            adminEarning: parseFloat(a).toFixed(2),
          });
        }
      });
    }
  };

  // const getCsvData = useCallback(() => {
  //   console.log(data, "Earning detail data");
  //   if (data) {
  //     let arr = [...data];
  //     let datas = arr.map((st) => {
  //       let student = st?.student_details;
  //       return {
  //         id: student?.studentId,
  //         bookingId: it?.bookingId,
  //         date: it?.date,
  //         first_name: student?.first_name,
  //         last_name: student?.last_name,
  //         medical_note: student?.medical_note,
  //         address: student?.address,
  //         discipline: student?.discipline_details?.name,
  //         image: student?.image,
  //         emergency_contactNo: student?.emergency_contactNo,
  //         emergency_countryCode: student?.emergency_countryCode,
  //         dob: student?.dob ? moment(student?.dob).format("DD MMM YYYY") : "",
  //         student_type: student?.student_type,
  //         areacode_details: student?.areacode_details?.name,
  //         school_details: student?.school_details?.name,
  //         gross_amount: student?.gross_amount,
  //         admin_earning: student?.admin_earning,
  //         net_amount: student?.net_amount,
  //         "payment date": student?.createdAt
  //           ? moment(student?.createdAt).format("DD MMM YYYY")
  //           : "",
  //       };
  //     });
  //     setCsvData(datas);
  //   }
  //   // return datas;
  // }, [data?.student_list]);

  // useEffect(() => {
  //   if (data) {
  //     getCsvData();
  //   }
  // }, [getCsvData, data]);

  return (
    <article className="col-lg-9">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center mb-3">
          <div className="col-auto">
            <BackButton />
          </div>
          <div className="col">
            <h3 className="mb-0">Teacher Earning Details</h3>
          </div>
          <div className="col-auto ms-auto">
            <div className="d-flex align-items-center gap-2">
                <img 
                  src={teacher?.image || "assets/images/upload-img.png"} 
                  alt={teacher?.full_name} 
                  style={{
                    width: '40px', 
                    height: '40px', 
                    borderRadius: '50%', 
                    objectFit: 'cover'
                  }} 
                />
              <span style={{fontSize: '0.9rem', fontWeight: '500'}}>{teacher?.full_name}</span>
            </div>
          </div>
        </div>

        <div className="row mt-3 align-items-end g-2">
          <div className="col-md-2 mb-2">
            <input 
              type="text" 
              className="form-control" 
              placeholder="Search by Class / Event"
              style={{height: '50px', fontSize: '0.95rem'}}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="col-md-2 mb-2">
            <select
              className="form-control form-select"
              onChange={(e) => {
                if (e.target.value === "") {
                  setSchoolId("");
                }
                setAreacode(e.target.value);
              }}
              style={{height: '50px', fontSize: '0.95rem'}}
            >
              <option value="">Select Region</option>
              {Array.isArray(arealist) && arealist.map((item, i) => (
                <option value={item?.id} key={i}>
                  {item?.areacode}
                </option>
              ))}
            </select>
          </div>
          {areacode && (
            <div className="col-md-2 mb-2">
              <select
                className="form-control form-select"
                onChange={(e) => {
                  setSchoolId(e.target.value);
                }}
                style={{height: '50px', fontSize: '0.95rem'}}
              >
                <option value="">Select Location</option>
                {Schoollist?.map((item, i) => (
                  <option value={item?.id} key={i}>
                    {item?.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="col-md-2 mb-2">
            <DatePicker
              value={start_date}
              onChange={(val) => {
                setStart_date(val.toDate());
              }}
              containerStyle={{width: '100%'}}
              style={{borderRadius: '10px !important', border: '1px solid #ced4da !important', padding: '0.5rem 0.75rem', fontSize: '0.95rem', outline: 'none !important', boxShadow: 'none !important', backgroundColor: '#fff', height: '50px'}}
              placeholder="Start Date"
              className="custom-datepicker"
            />
          </div>
          <div className="col-md-2 mb-2">
            <DatePicker
              value={end_date}
              onChange={(val) => {
                setEnd_date(val.toDate());
              }}
              containerStyle={{width: '100%'}}
              style={{borderRadius: '10px !important', border: '1px solid #ced4da !important', padding: '0.5rem 0.75rem', fontSize: '0.95rem', outline: 'none !important', boxShadow: 'none !important', backgroundColor: '#fff', height: '50px'}}
              placeholder="End Date"
              minDate={start_date || new Date()}
              className="custom-datepicker"
            />
          </div>
          <div className="col-md-2 mb-2 text-end">
            {csvData && (
              <CSVLink filename={"earnings.csv"} data={csvData || []}>
                <button type="button" className="btn btn-save p-2 fs-6" style={{height: '50px'}}>
                  <i className="fa fa-download me-1"></i>Download CSV
                </button>
              </CSVLink>
            )}
          </div>
         
          <div className="col-sm-12">
            <div className="table-responsive text-center">
              <table className="table storetable">
                <thead className="text-center">
                  <tr>
                    {/* <th scope="col">Student name</th> */}
                    <th scope="col">Booked For</th>
                    <th scope="col">Type</th>
                    <th scope="col">Venue </th>
                    {/* <th scope="col">Order Id</th> */}
                    <th scope="col">date</th>
                    <th scope="col">Gross Amount</th>
                    <th scope="col">Franchise Fee</th>
                    <th scope="col">Hall Fee</th>
                    <th scope="col">Admin Commision</th>
                    <th scope="col">Teacher Net Income</th>
                    <th scope="col">Admin Net Income</th>
                    <th scope="col">action</th>
                  </tr>
                  <tr className="border-0 bg-none invisible">
                    <td className="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={11}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {data?.length > 0 ? (
                        <>
                        {data?.map((item, i) => {
                          const netAmount = (item?.amount * adminPercent) / 100;
                          const hall_fee = parseFloat(item?.hall_fee) || 0;
                          const franchise_fee = parseFloat(item?.franchise_fee) || 0;
                          const fee = parseFloat((hall_fee + franchise_fee).toFixed(2));
                          const admin_commision = parseFloat(((item?.amount - fee) * adminPercent / 100).toFixed(2));
                          const teacher_net_income = parseFloat((item?.amount - (admin_commision + fee)).toFixed(2));
                          const admin_net_income = parseFloat((admin_commision + fee).toFixed(2));
                          return (
                            <tr key={i}>
                              {/* <td>
                                {item?.student_details?.first_name}{" "}
                                {item?.student_details?.last_name}
                              </td> */}
                              <td>
                                {item?.class_details
                                  ? `${item?.class_details?.name}`
                                  : item?.event_details
                                  ? `${item?.event_details?.name}`
                                  : "NA"}
                              </td>
                              <td>
                                {item?.class_details
                                  ? "Class"
                                  : item?.event_details
                                  ? "Event"
                                  : "NA"}
                              </td>
                              <td>
                                {item?.class_details
                                  ? `${item?.class_details?.school_details?.name}, ${item?.class_details?.school_details?.address}`
                                  : item?.event_details
                                  ? `${item?.event_details?.school_details?.name}, ${item?.event_details?.school_details?.address}`
                                  : "NA"}
                              </td>
                              {/* <td>{item?.id}</td> */}
                              <td>
                                {item?.date
                                  ? moment(item?.date).format("DD MMM YYYY")
                                  : "NA"}
                              </td>
                              <td style={{color: '#2196F3', fontWeight: '450'}}>
                                <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                                {parseFloat(Number(item?.amount)) || 0}
                              </td>
                              <td style={{color: '#FF9800', fontWeight: '450'}}><i className="fa fa-gbp" aria-hidden="true"></i>{" "}{franchise_fee}</td>
                              <td style={{color: '#FF9800', fontWeight: '450'}}><i className="fa fa-gbp" aria-hidden="true"></i>{" "}{hall_fee}</td>
                              <td style={{color: '#FF9800', fontWeight: '450'}}>
                                <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                                {admin_commision || 0}
                              </td>
                              <td  style={{color: '#15c51d', fontWeight: '450'}}>
                                <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                                {teacher_net_income || 0}
                              </td>
                              <td style={{color: '#15c51d', fontWeight: '450'}}>
                                <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                                {admin_net_income || 0}
                              </td>
                              <td>
                                <div className="d-flex justify-content-center action">
                                  <button className="btn">
                                    <Link
                                      to={`/earnings-by-staff-detail/${item?.id}`}
                                      title="View Detailed Breakdown"
                                    >
                                      <img src="assets/images/view.png" alt="" />
                                    </Link>
                                  </button>
                                </div>
                              </td>

                              {/* <td>
                      <div className="d-flex justify-content-center action">
                        <button className="btn">
                          <Link to="/earnings-by-staff/1">
                            <img src="assets/images/view.png" alt="" />
                          </Link>
                        </button>
                        <button
                          className="btn"
                          data-bs-toggle="modal"
                          data-bs-target="#deleteModal"
                        >
                          <img src="assets/images/delete.png" alt="" />
                        </button>
                        <button className="btn">
                          <input
                            type="checkbox"
                            className="toggle"
                            checked=""
                          />
                        </button>
                      </div>
                    </td> */}
                            </tr>
                          );
                        })}
                        {/* Total Row */}
                        <tr>
                          <td colSpan={4} style={{textAlign: 'right'}}><b>Total : </b></td>
                          <td>
                            <span style={{color: '#2196F3', fontWeight: '450'}}>£{parseFloat(data.reduce((sum, item) => sum + (parseFloat(item?.amount) || 0), 0).toFixed(2))}</span>
                          </td>
                          <td>
                            <span style={{color: '#FF9800', fontWeight: '450'}}>£{parseFloat(data.reduce((sum, item) => sum + (parseFloat(item?.franchise_fee) || 0), 0).toFixed(2))}</span>
                          </td>
                          <td>
                            <span style={{color: '#FF9800', fontWeight: '450'}}>£{parseFloat(data.reduce((sum, item) => sum + (parseFloat(item?.hall_fee) || 0), 0).toFixed(2))}</span>
                          </td>
                          <td>
                            <span style={{color: '#FF9800', fontWeight: '450'}}>£{parseFloat(data.reduce((sum, item) => {
                              const hall_fee = parseFloat(item?.hall_fee) || 0;
                              const franchise_fee = parseFloat(item?.franchise_fee) || 0;
                              const fee = hall_fee + franchise_fee;
                              const admin_commision = ((item?.amount - fee) * adminPercent / 100);
                              return sum + admin_commision;
                            }, 0).toFixed(2))}</span>
                          </td>
                          <td>
                            <span style={{color: '#15c51d', fontWeight: '450'}}>£{parseFloat(data.reduce((sum, item) => {
                              const hall_fee = parseFloat(item?.hall_fee) || 0;
                              const franchise_fee = parseFloat(item?.franchise_fee) || 0;
                              const fee = hall_fee + franchise_fee;
                              const admin_commision = ((item?.amount - fee) * adminPercent / 100);
                              const teacher_net_income = item?.amount - (admin_commision + fee);
                              return sum + teacher_net_income;
                            }, 0).toFixed(2))}</span>
                          </td>
                          <td>
                            <span style={{color: '#15c51d', fontWeight: '450'}}>£{parseFloat(data.reduce((sum, item) => {
                              const hall_fee = parseFloat(item?.hall_fee) || 0;
                              const franchise_fee = parseFloat(item?.franchise_fee) || 0;
                              const fee = hall_fee + franchise_fee;
                              const admin_commision = ((item?.amount - fee) * adminPercent / 100);
                              const admin_net_income = admin_commision + fee;
                              return sum + admin_net_income;
                            }, 0).toFixed(2))}</span>
                          </td>
                          <td></td>
                        </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan={11}>No data found.</td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            {data?.length > 0 && (
              <div className="text-center">
                <span
                  className={
                    limit === 10
                      ? "manualPagination active"
                      : "manualPagination"
                  }
                  onClick={() => {
                    setLimit(10);
                    setPage("1");
                  }}
                >
                  10
                </span>
                <span
                  className={
                    limit === 25
                      ? "manualPagination active"
                      : "manualPagination"
                  }
                  onClick={() => {
                    setLimit(25);
                    setPage("1");
                  }}
                >
                  25
                </span>
                <span
                  className={
                    limit === 100
                      ? "manualPagination active"
                      : "manualPagination"
                  }
                  onClick={() => {
                    setLimit(100);
                    setPage("1");
                  }}
                >
                  100
                </span>
                <span
                  className={
                    limit === ""
                      ? "manualPagination active"
                      : "manualPagination"
                  }
                  onClick={() => {
                    setLimit("");
                    // setPage("1");
                  }}
                >
                  All
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={() => {
          setShow(!show);
        }}
        centered
        size="md"
      >
        <div class="modal-content body-bg p-3">
          <div class="modal-header border-0 justify-content-center">
            <h6>Filter</h6>
            <button
              type="button"
              class="btn-close"
              onClick={() => {
                setShow(!show);
              }}
            ></button>
          </div>
          <div class="modal-body mb-4">
            <form class="form-style">
              {/* <div class="form-group">
                  <h5>By Teacher</h5>
                  <select class="form-control form-select">
                    <option>Select Teacher Name</option>
                  </select>
                </div> */}
              <div class="form-group">
                <h5>Start Date</h5>
                <div class="input-container">
                  {/* <input
                      type="text"
                      class="form-control"
                      placeholder="Date"
                    /> */}
                  <DatePicker
                    value={start_date}
                    onChange={(val) => {
                      setStart_date(val.toDate());
                    }}
                    containerClassName="form-control"
                  />
                  <img
                    src="assets/images/choose-date.png"
                    class="field-icon"
                    alt=""
                  />
                </div>
              </div>
              <div class="form-group">
                <h5>End Date</h5>
                <div class="input-container">
                  {/* <input
                      type="text"
                      class="form-control"
                      placeholder="Date"
                    /> */}
                  <DatePicker
                    value={end_date}
                    onChange={(val) => {
                      setEnd_date(val.toDate());
                    }}
                    containerClassName="form-control"
                    minDate={start_date || new Date()}
                  />
                  <img
                    src="assets/images/choose-date.png"
                    class="field-icon"
                    alt=""
                  />
                </div>
              </div>
              <div class="text-center">
                <span
                  onClick={() => {
                    setStart_date("");
                    setEnd_date("");
                  }}
                  className="text-dark cursor-pointer"
                >
                  Reset
                </span>
              </div>
              <div class="text-center">
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                  class="btn btn-accept btn-view mt-2"
                  disabled={submitting}
                >
                  {submitting ? <Loader /> : "Apply"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </article>
  );
}

export default TeacherEarningDetails;
